<template>
    <!-- DocPOPUP -->
        <v-dialog v-model="mustShowDocPopup" :content-class="contentClass"
                  :max-width="maxWidth"
                  :persistent="persistent"
                  id="close-popup"
                  scrollable
                  v-bind="dialogBindings"
                  >
            <v-card v-if="getDocData" :class="cardClass">
                <v-card-title style="justify-content: center">
                        <span @click="closeDocPopup()" class="float-left" style="position: absolute;left: 15px; top: 15px;cursor: pointer">
                              <img alt="close icon" src="../../../assets/svg/material-icons-alternatives/Close_Grey.svg" width="24px" height="24px">
                        </span>
                    <span class="font-weight-bold" style="font-size: 16px;">
                        {{ text(getDocData.title) }}
                    </span>
                </v-card-title>
                <v-card-text class="padding-left-l padding-right-l" v-html="getDocData.content">
                </v-card-text>

            </v-card>
        </v-dialog>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'DocPopup',


    props: {
      contentClass : {
          type: String,
          required: false,
          default: 'display-info-popup'
      },

      cardClass: {
          type: String,
          required: false,
          default: 'no-padding info-popup show-info-popup'
      },

      persistent: {
          type: Boolean,
          required: false,
          default: true
      },
        maxWidth: {
          type: Number,
          required: false,
          default: 600
        }
    },

    computed: {
        ...mapGetters({
            getDocData: 'DocStore/getDocData',
        }),


        mustShowDocPopup: {
            get() {
                return (this.getDocData !== null) ? true : false;
            },
            set(newValue) {
                if (newValue === false) {
                    this.closeDocPopup();
                }
            }
        },

        dialogBindings () {
            return {
                transition: 'dialog-bottom-transition'
            }
        }

    },

    methods: {
        closeDocPopup() {
            this.$store.commit('DocStore/setDocData', null);
            this.PfChatbotPlugin.showScroll();
        },

    }
}
</script>




// WEBPACK FOOTER //
// src/common/components/shared/DocPopup.vue